<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{ createOrUpdate }}</h4>
      </div>
      <div class="level-right">
        <button
          class="button is-small"
          v-if="ticketingForItem.ticketingForItemId != 0"
          @click="viewLog(ticketingForItem.ticketingForItemId)"
        >
          <i class="fas fa-history"></i>&nbsp;Log
        </button>
        &nbsp;
        <div
          class="select is-small"
          v-if="
            hasTechnicalPrivOnly ||
              hasTechnicalAdminPriv ||
              hasAdminSalesAndMainAdminPriv
          "
        >
          <select v-model="ticketingForItem.progressStatus">
            <option value="0">Pending</option>
            <option value="1">In progress</option>
            <option value="2">Completed</option>
            <option value="3">Canceled</option>
          </select>
        </div>
        <div v-else>
          <span v-if="ticketingForItem.ticketingForItemId == 0">
            <b-tag style="font-size:9px;background-color:#E08A1E;color:white">
              Pending
            </b-tag>
          </span>
          <span v-else>
            <span v-if="ticketingForItem.progressStatus == 0">
              <b-tag style="font-size:9px;background-color:#E08A1E;color:white">
                Pending
              </b-tag>
            </span>
            <span v-if="ticketingForItem.progressStatus == 1">
              <b-tag style="font-size:9px;background-color:#22A7F0;color:white">
                In progress
              </b-tag>
            </span>
            <span v-if="ticketingForItem.progressStatus == 2">
              <b-tag style="font-size:9px;background-color:#26C281;color:white">
                Completed
              </b-tag>
            </span>
            <span v-if="ticketingForItem.progressStatus == 3">
              <b-tag style="font-size:9px;background-color:#C91F37;color:white">
                Canceled
              </b-tag>
            </span>
          </span>
        </div>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Agent name</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="agentName"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Date</label>
          <div class="control">
            <input
              type="date"
              class="input is-small"
              v-model="ticketingForItem.date"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Assigned Tech. Staff</label>
          <div class="control">
            <span v-if="hasTechnicalAdminPriv || hasAdminSalesAndMainAdminPriv">
              <b-autocomplete
                v-model="techStaffName"
                size="is-small"
                :data="techStaff"
                placeholder="Search technical staff"
                @select="option => (selectedUser = option)"
                @input="searchTechStaff"
              >
                <template slot="empty">
                  <span v-if="isFetchingUserAgents">
                    Please wait...
                  </span>
                  <span v-if="techStaff.length === 0">
                    No results found
                  </span>
                </template>
              </b-autocomplete>
            </span>
            <span v-else>
              <span v-if="techStaffName">
                {{ techStaffName }}
              </span>
              <span v-else>
                <i>Unassigned</i>
                <span v-if="hasTechnicalPrivOnly">
                  &nbsp;
                  <b-button
                    type="is-info"
                    rounded
                    size="is-small"
                    :loading="isAssigningButton"
                    @click="assignToSelfTechnicalStaff"
                    >Assign to myself</b-button
                  >
                </span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Scope of work</label>
          <div class="select is-small">
            <select v-model="ticketingForItem.ticketingSow">
              <option value="0">Assemble only</option>
              <option value="1">Assemble & install</option>
              <option value="2">Install only</option>
              <option value="3">Repair/Troubleshoot</option>
              <option value="4">On-site scheduled service</option>
              <option value="5">Check/Diagnose</option>                                                                                                        </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Item type</label>
          <div class="select is-small">
            <select v-model="ticketingForItem.ticketingItemType">
              <option value="0">Desktop PC</option>
              <option value="1">Laptop</option>
              <option value="2">Server</option>
              <option value="3">Peripherals</option>
              <option value="4">Others</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-1" v-if="ticketingForItem.ticketingSow != 4">
        <div class="field">
          <label class="label is-small">QTY</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              v-model="ticketingForItem.qty"
              v-validate="'required'"
              name="Qty"
              placeholder="0"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first("Qty")
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2" v-if="ticketingForItem.ticketingSow != 4">
        <div class="field">
          <label class="label is-small">Clone</label>
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="ticketingForItem.clone"
              style="height: 80px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2" v-if="ticketingForItem.ticketingSow != 4">
        <div class="field">
          <label class="label is-small">Branded</label>
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="ticketingForItem.branded"
              style="height: 80px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Clients</label>
          <div class="control">
            <b-autocomplete
              v-model="clientName"
              size="is-small"
              :data="clients"
              placeholder="Search clients"
              @select="option => (selectedClient = option)"
              @input="searchClients"
              v-validate="'required'"
              name="Client"
              :loading="isFetchingClients"
            >
              <template slot="empty">
                <span v-if="isFetchingClients">
                  Please wait...
                </span>
                <span v-if="clients.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first("Client")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label is-small">Agent note</label>
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="ticketingForItem.agentNote"
              style="height: 200px"
            />
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label is-small">Tech note</label>
          <div class="control">
            <span
              v-if="
                hasTechnicalAdminPriv ||
                  hasAdminSalesAndMainAdminPriv ||
                  hasTechnicalPrivOnly
              "
            >
              <textarea
                type="text"
                class="input is-small"
                v-model="ticketingForItem.techNote"
                style="height: 200px"
              />
            </span>
            <span v-else>
              <span v-if="ticketingForItem.techNote">
                <i>{{ ticketingForItem.techNote }}</i>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <span v-if="hasTechnicalAdminPriv">
          <span class="has-text-info">
            <i
              >Note: You can only update the "Status", "Tech note" & "Assigned
              Tech. Staff" fields</i
            >
          </span>
          &nbsp;
          <b-button
            type="is-success"
            size="is-small"
            :loading="isSaving"
            @click="updateStatusByTechAdmin"
            >Update Assigned Tech. Staff</b-button
          >
        </span>
        <span v-else-if="hasTechnicalPrivOnly">
          <span class="has-text-info">
            <i
              >Note: You can only update the "Status" and the "Tech note"
              fields</i
            >
          </span>
          &nbsp;
          <b-button
            type="is-success"
            size="is-small"
            :loading="isSaving"
            @click="updateStatusByTechStaff"
            >Update</b-button
          >
        </span>
        <span v-else>
          <b-button
            type="is-success"
            size="is-small"
            :loading="isSaving"
            @click="save"
            >Save</b-button
          >
        </span>
        &nbsp;
        <router-link
          :to="{
            name: 'List of Ticketing for Item',
            params: { byStatus: 'all', pageSize: 10 }
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <Log />
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import axios from "axios";
import AppToast from "../frontend/appToast";
import Loading from "vue-loading-overlay";
import VueJWT from "vuejs-jwt";
import AuthService from "../../_services/auth";
import moment from "moment";
import { DateTimeFormatForInput } from "../../helpers/momentFormat";
import { mapState, mapActions } from "vuex";
import Log from "./Log";

Vue.use(VueJWT);

const appToast = new AppToast();
const authService = new AuthService();

export default {
  components: {
    Loading,
    Log
  },
  data: () => ({
    // user
    agentName: "",
    agentId: 0,
    createOrUpdate: "Create",
    isFetchingSavedInfo: false,
    ticketingForItem: {
      ticketingForItemId: 0,
      ticketingSow: 0,
      ticketingItemType: 0,
      progressStatus: 0
    },
    isSaving: false,
    isAssigningButton: false,
    // search clients
    clientName: "",
    clients: [],
    selectedClient: 0,
    isFetchingClients: false,
    hasTechnicalPrivOnly: authService.hasTechnicalPrivOnly(),
    hasTechnicalAdminPriv: authService.hasTechnicalAdminPriv(),
    hasAdminSalesAndMainAdminPriv: authService.hasAdminSalesAndMainAdminPriv(),
    hasAdminSalesAndPullOut: authService.hasAdminSalesOrSalesPullOutPriv(),
    // search user agent
    techStaffName: "",
    techStaff: [],
    selectedUser: 0,
    isFetchingUserAgents: false
  }),
  created() {
    const ticketingForItemId = this.$route.params.ticketingForItemId;
    var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
    if (ticketingForItemId) {
      this.getTicketingForItemById(ticketingForItemId);
    } else {
      // CREATE Mode
      this.getCurrentDateFromServer();
      this.agentName = decodedToken.unique_name;
    }
  },
  methods: {
    ...mapActions("ticketingforitem", ["openLogModal"]),
    goBack() {
      this.$router.go(-1);
    },
    viewLog(id) {
      this.openLogModal({
        showLogModal: true,
        ticketingForItemId: id
      });
    },
    searchTechStaff() {
      axios
        .get(`api/users/ac/technical-staff-by-name/${this.techStaffName}`)
        .then(response => {
          this.techStaff = response.data;
        })
        .catch(error => console.log(error.response));
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then(response => {
          this.ticketingForItem.date = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    default() {
      this.$nextTick(() => {
        this.$validator.reset();
      });

      this.createOrUpdate = "Create";
    },
    getTicketingForItemById(id) {
      this.isFetchingSavedInfo = true;
      this.createOrUpdate = "...";
      axios
        .get(`api/ticketingforitems/${id}`)
        .then(response => {
          response.data.date = DateTimeFormatForInput(response.data.date);
          this.clientName = response.data.client;
          this.agentName = response.data.user;
          this.techStaffName = response.data.assignedTechUser;
          this.ticketingForItem = response.data;
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            appToast.danger(error.response.data);
          }
        })
        .then(() => {
          this.isFetchingSavedInfo = false;
          this.createOrUpdate = "Edit";
        });
    },
    assignToSelfTechnicalStaff() {
      if (this.hasTechnicalPrivOnly) {
        this.isAssigningButton = true;
        axios
          .put(
            `api/ticketingforitems/take-by-current-login/${this.ticketingForItem.ticketingForItemId}`
          )
          .then(response => {
            appToast.success(response.data);
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              appToast.danger(error.response.data);
            }
          })
          .then(() => {
            this.isAssigningButton = false;
            this.getTicketingForItemById(
              this.ticketingForItem.ticketingForItemId
            );
          });
      }
    },
    updateStatusByTechStaff() {
      if (this.hasTechnicalPrivOnly) {
        this.isSaving = true;
        const dataToUpdate = {
          ticketingForItemId: this.ticketingForItem.ticketingForItemId,
          progressStatus: this.ticketingForItem.progressStatus,
          techNote: this.ticketingForItem.techNote
        };

        axios
          .post(
            `api/ticketingforitems/update-status-by-tech-staff/`,
            dataToUpdate
          )
          .then(response => {
            appToast.success(response.data);
            this.$router.go(-1);
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              appToast.danger(error.response.data);
            }
          })
          .then(() => {
            this.isSaving = false;
          });
      }
    },
    updateStatusByTechAdmin() {
      if (this.hasTechnicalAdminPriv) {
        this.isSaving = true;
        const dataToUpdate = {
          ticketingForItemId: this.ticketingForItem.ticketingForItemId,
          progressStatus: this.ticketingForItem.progressStatus,
          techNote: this.ticketingForItem.techNote,
          assignedTechStaff: this.ticketingForItem.assignedTechStaffId
        };

        axios
          .post(
            `api/ticketingforitems/update-status-assigned-tech-staff-by-tech-admin/`,
            dataToUpdate
          )
          .then(response => {
            appToast.success(response.data);
            this.$router.go(-1);
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              appToast.danger(error.response.data);
            }
          })
          .then(() => {
            this.isSaving = false;
          });
      }
    },
    save() {
      if (!this.ticketingForItem.clientId) {
        appToast.danger("Client is empty.");
        return false;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isSaving = true;
          // CREATE
          if (this.ticketingForItem.ticketingForItemId == 0) {
            axios
              .post(`api/ticketingforitems/`, this.ticketingForItem)
              .then(response => {
                appToast.success(response.data);
                this.$router.go(-1);
              })
              .catch(error => {
                if (error.response) {
                  appToast.danger(error.response.data);
                }
              })
              .then(() => {
                this.isSaving = false;
              });
          } else {
            axios
              .put(
                `api/ticketingforitems/${this.ticketingForItem.ticketingForItemId}`,
                this.ticketingForItem
              )
              .then(response => {
                appToast.success(response.data);
              })
              .catch(error => {
                if (error.response) {
                  appToast.danger(error.response.data);
                }
              })
              .then(() => {
                this.isSaving = false;
              });
          }
        }
      });
    },
    searchClients() {
      if(this.clientName){
      axios
        .get(`api/searchqueries/clients-by-name/${this.clientName}/${this.hasAdminSalesAndPullOut}`)
        .then(response => {
          this.clients = response.data;
        })
        .catch(error => console.log(error.response));
        }
    }
  },
  watch: {
    selectedClient() {
      if (this.selectedClient.id) {
        this.ticketingForItem.clientId = this.selectedClient.id;
      } else {
        this.selectedClient = 0;
      }
    },
    selectedUser() {
      if (this.selectedUser.id) {
        this.ticketingForItem.assignedTechStaffId = this.selectedUser.id;
        this.techStaffName = this.selectedUser.value;
      } else {
        this.selectedUser = 0;
        this.techStaffName = "";
      }
    }
  }
};
</script>
